function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffffff",
  d: "M5.45 4.263v11.863l8.452 4.61V8.875L5.45 4.264zm2.191-.513l7.37 4.02c.241.132.391.384.391.659v7.392h3.024V3.75H7.641zM15.402 22c0 .57-.609.931-1.109.658L4.341 17.23c-.241-.132-.391-.384-.391-.659V3.014c-.001-.066.006-.133.023-.2l.005-.017c.015-.053.036-.106.064-.156.013-.025.027-.048.043-.07.061-.088.14-.161.232-.216.09-.053.188-.087.29-.1h.01c.033-.004.066-.006.098-.005h14.461c.414 0 .75.336.75.75v13.571c0 .415-.336.75-.75.75h-3.774V22z"
});

var SvgIcClients = function SvgIcClients(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcClients, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_clients.949a9d81.svg";
export { ForwardRef as ReactComponent };